import { useApi } from "../contexts/api";

export const useGerenciadorFiscalService = () => {
  const { get, put, post, getFile } = useApi();

  return {
    async buscarSeries() {
      const response = await get("/impostos/nfe/series");
      return response.data;
    },

    async inutilizar({ serie, nInicial, nFinal, motivo, modeloFiscal }) {
      const numeros = [];
      for (let i = Number(nInicial); i <= Number(nFinal); i++) {
        numeros.push(i);
      }
      // NFC-e usa o mesmo endpoint de NF-e (InutilizarNfeSaidaService, que já trata
      // DocumentoEnum.NFCE e busca o Emissor Fiscal por empresa). O endpoint dedicado
      // /impostos/nfce/inutilizar-em-lote busca o Emissor Fiscal por sessão vinculada a uma
      // estação de trabalho (fluxo do Waychef/PDV) - no Waybe (sessão web) essa vinculação não
      // existe e a chamada falha com "Emissor Fiscal não cadastrado" mesmo com o emissor
      // cadastrado na empresa.
      const response = await put("/impostos/nfe/inutilizar", {
        justificativaInutilizacao: motivo,
        numerosInutilizar: numeros,
        serie,
        modeloFiscal,
      });
      return response.data;
    },

    async consultarStatusServico({ modeloFiscal }) {
      const endpoint =
        modeloFiscal === "NFCE"
          ? "/impostos/nfce/consultar-status-nfce"
          : "/impostos/nfe/consultar-status-servico";
      const response = await get(endpoint);
      return response.data;
    },

    // Deprecado pelo backend (alta latência) - manter só pro modo genérico, quando não se tem
    // idNota (usuário digitou a chave manualmente). Ver consultarSituacaoPorId.
    async consultarSituacao({ chaveAcesso }) {
      const response = await get(`/impostos/nfe/situacao/chave/${chaveAcesso}`);
      return response.data;
    },

    // Consulta de situação pelo idNota - endpoint recomendado pelo backend em vez do de chave
    // (usado quando o modal já sabe de qual nota se trata, ex.: aberto via botão "Gerenciar").
    async consultarSituacaoPorId(idNota) {
      const response = await get(`/impostos/nfe/situacao/${idNota}`);
      return response.data;
    },

    async consultarCadastroContribuinte({ documento, uf }) {
      const response = await get(
        `/impostos/nfe/consulta-contribuinte?documento=${documento}&uf=${uf}`
      );
      return response.data;
    },

    // Task 2.6: autorizar (emitir) NF-e / NFC-e
    async autorizarNfe({ idNota, modeloFiscal }) {
      const endpoint =
        modeloFiscal === "NFCE"
          ? `/impostos/nfce/emitir-nfce/${idNota}`
          : `/impostos/nfe/emitir/${idNota}`;
      const response = await put(endpoint);
      return response.data;
    },

    // Task 5.5: cancelar NF-e / NFC-e
    async cancelarNfe({ idNota, motivoCancelamento, modeloFiscal }) {
      const endpoint =
        modeloFiscal === "NFCE"
          ? `/impostos/nfce/cancelar/${idNota}`
          : `/impostos/nfe/cancelar/${idNota}`;
      const response = await put(endpoint, { motivoCancelamento, gerarImpressao: false });
      return response.data;
    },

    // Carta de Correção (CC-e) - só existe pra NF-e, SEFAZ não suporta CC-e pra NFC-e (modelo 65).
    // Resposta é o XML cru do evento processado (não um DTO tipado) - parsear com extrairTagXml.
    async emitirCartaCorrecao({ idNota, textoCorrecao }) {
      const response = await post(`/impostos/nfe/carta-correcao/${idNota}`, { textoCorrecao });
      return response.data;
    },

    // Gerar DANFE em PDF de uma NF-e autorizada (NfeController.danfe, api-impostos, branch VR-323).
    // Sem equivalente para NFC-e - o modelo NFCE não tem DANFE, só o Imprimir do próprio ambiente.
    async gerarDanfe(idNota) {
      const response = await getFile(`/impostos/nfe/danfe/${idNota}`);
      return response.data;
    },

    // Gerar PDF de uma carta de correção (CC-e) já registrada (NfeController.pdfCartaCorrecao,
    // api-impostos). `sequencia` é a sequência do evento na SEFAZ, não o índice na lista.
    async gerarPdfCartaCorrecao(idNota, sequencia) {
      const response = await getFile(
        `/impostos/nfe/carta-correcao/${idNota}/pdf?sequencia=${sequencia}`
      );
      return response.data;
    },
  };
};
